import { ResponsiveContainer } from "~/common/ResponsiveContainer";

export const ListContainer = ({ children }: { children?: React.ReactNode }) => {
  return (
    <ResponsiveContainer debug={false}>
      <div className="tw:flex tw:flex-row tw:justify-center">
        <div className="tw:mx-20 tw:max-w-[1200px]">{children}</div>
      </div>
    </ResponsiveContainer>
  );
};
